'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/scheduler.production.min.js');
} else {
  module.exports = require('./cjs/scheduler.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-lazyload/node_modules/react-dom/node_modules/scheduler/index.js
// module id = 1158
// module chunks = 8